import { supabase } from '../../../infra_/supabase/supabaseClient.js';

export class PeriodoInventarioRepository {

  async obtenerPeriodoAbierto() {

    const { data, error } = await supabase
      .from("periodos_inventario")
      .select("*")
      .eq("estado", "abierto")
      .maybeSingle();

    if (error) throw error;

    return data;
  }

}